import { darken } from 'polished';
import ReactModal from 'react-modal';
import styled from 'styled-components';

import { COLORS } from 'styles/constants';

export const Container = styled(ReactModal)``;

export const ImageContainer = styled.div`
  width: 500px;
  padding: 10px;

  background: ${COLORS.white};
  border-radius: 10px 10px 0 0;

  display: flex;
  justify-content: center;
  align-items: center;

  img {
    width: 180px;
  }

  @media only screen and (max-width: 900px) {
    width: 90%;
  }
`;

export const Content = styled.div`
  padding: 40px;
  width: 500px;

  color: ${COLORS.white};
  background: ${COLORS.primary};
  border-radius: 0 0 10px 10px;

  display: flex;
  flex-direction: column;
  align-items: center;

  p {
    margin-top: 20px;
    font-size: 20px;
    text-align: center;
  }

  span {
    font-size: 30px;
  }

  @media only screen and (max-width: 900px) {
    width: 90%;
  }
`;

export const CloseButton = styled.button`
  width: 200px;
  padding: 20px;
  margin-top: 30px;

  font-size: 22px;
  color: ${COLORS.darktext};
  background: ${COLORS.white};
  border: none;
  border-radius: 3px;

  &:hover {
    background: ${darken(0.08, COLORS.white)};
  }
`;
